<script lang="ts">
  import { Hero, type HeroProps } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { HeroModuleProps } from './types';

  const {
    entryId,
    customCssClass,
    colorMode,
    variant,
    eyebrow,
    heading,
    subheading,
    background,
    content,
    ctaItems,
  }: HeroModuleProps = $props();

  const heroProps: HeroProps = { variant, colorMode, eyebrow, heading, subheading };
</script>

{#snippet heroModuleBackground()}
  <DynamicChildrenComponent children={background} />
{/snippet}

{#snippet heroModuleContent()}
  <DynamicChildrenComponent children={content} />
{/snippet}

{#snippet heroModuleCtaItems()}
  <DynamicChildrenComponent children={ctaItems} />
{/snippet}

<section class="HeroModule {customCssClass}" data-entry-id={entryId}>
  {#if !content && !background && !ctaItems}
    <Hero {...heroProps} />
  {/if}

  {#if !content && !background && ctaItems}
    <Hero {...heroProps}>
      {#snippet ctaItems()}
        {@render heroModuleCtaItems()}
      {/snippet}
    </Hero>
  {/if}

  {#if !content && background && !ctaItems}
    <Hero {...heroProps}>
      {#snippet background()}
        {@render heroModuleBackground()}
      {/snippet}
    </Hero>
  {/if}

  {#if !content && background && ctaItems}
    <Hero {...heroProps}>
      {#snippet background()}
        {@render heroModuleBackground()}
      {/snippet}
      {#snippet ctaItems()}
        {@render heroModuleCtaItems()}
      {/snippet}
    </Hero>
  {/if}

  {#if content && !background && !ctaItems}
    <Hero {...heroProps}>
      {#snippet content()}
        {@render heroModuleContent()}
      {/snippet}
    </Hero>
  {/if}

  {#if content && !background && ctaItems}
    <Hero {...heroProps}>
      {#snippet content()}
        {@render heroModuleContent()}
      {/snippet}
      {#snippet ctaItems()}
        {@render heroModuleCtaItems()}
      {/snippet}
    </Hero>
  {/if}

  {#if content && background && !ctaItems}
    <Hero {...heroProps}>
      {#snippet content()}
        {@render heroModuleContent()}
      {/snippet}
      {#snippet background()}
        {@render heroModuleBackground()}
      {/snippet}
    </Hero>
  {/if}

  {#if content && background && ctaItems}
    <Hero {...heroProps}>
      {#snippet background()}
        {@render heroModuleBackground()}
      {/snippet}
      {#snippet content()}
        {@render heroModuleContent()}
      {/snippet}
      {#snippet ctaItems()}
        {@render heroModuleCtaItems()}
      {/snippet}
    </Hero>
  {/if}
</section>
